(function () {
    'use strict';

    const FAVORITES_KEY = 'favoriteTrailers';
    const MAX_FAVORITES = 5;

    function getFavorites() {
        return JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
    }

    function saveFavorites(favorites) {
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    }

    function toggleFavorite(trailerId) {
        const idStr = String(trailerId); // Always treat IDs as strings
        let favorites = getFavorites();

        const index = favorites.indexOf(idStr);
        if (index !== -1) {
            // Remove from favorites
            favorites.splice(index, 1);
        } else {
            // Add to beginning, keep max 5
            favorites.unshift(idStr);
            if (favorites.length > MAX_FAVORITES) {
                favorites = favorites.slice(0, MAX_FAVORITES);
            }
        }

        saveFavorites(favorites);
        updateFavoriteIcons();
        renderFavoriteList();
    }

    function updateFavoriteIcons() {
        const favorites = getFavorites();
        document.querySelectorAll('.favorite-toggle').forEach(button => {
            const trailerId = button.getAttribute('data-trailer-id'); // Keep as string
            const icon = button.querySelector('.favorite-icon');
            if (!icon) return;

            if (favorites.includes(trailerId)) {
                icon.classList.add('text-red-500');
                icon.classList.remove('text-gray-400');
            } else {
                icon.classList.add('text-gray-400');
                icon.classList.remove('text-red-500');
            }
        });
    }

    function bindFavoriteButtons() {
        document.querySelectorAll('.favorite-toggle').forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const trailerId = button.getAttribute('data-trailer-id'); // Always string
                toggleFavorite(trailerId);
            });
        });
    }

    function renderFavoriteList() {
        const favorites = getFavorites();
        if (favorites.length === 0) {
            updateListDOM('<p class="text-gray-500">No favorites yet.</p>');
            return;
        }

        fetch(`/favoritetrailers?ids=${favorites.join(',')}`)
            .then(res => res.json())
            .then(trailers => {
                const html = trailers.map(t => `
                <a href="${t.detailUrl.url}" class="block hover:bg-gray-50 p-2 rounded">
                    <div class="flex items-center space-x-3">
                        <img src="${t.defaultImageUrl}" alt="${t.adTitle}" class="w-12 h-10 object-cover rounded">
                        <div>
                            <p class="text-sm font-medium text-gray-900">${t.adTitle}</p>
                            <p class="text-xs text-gray-500">${t.displayState ? t.displayState + ', ' : ''}${t.displayCity}</p>
                        </div>
                    </div>
                </a>
            `).join('');
                updateListDOM(html);
            });
    }

    function updateListDOM(html) {
        const mobileList = document.getElementById('favorites-list-mobile');
        const desktopList = document.getElementById('favorites-list-desktop');
        if (mobileList) mobileList.innerHTML = html;
        if (desktopList) desktopList.innerHTML = html;
    }

    //
    // ✅ NEW FUNCTION: setupFavoritesDropdownToggle
    //
    function setupFavoritesDropdownToggle() {
        const toggleBtn = document.getElementById('favorites-toggle');
        const dropdown = document.getElementById('favorites-dropdown');
        const wrapper = document.getElementById('favorites-wrapper');

        if (!toggleBtn || !dropdown || !wrapper) return;

        toggleBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            dropdown.classList.toggle('hidden');
        });

        document.addEventListener('click', (e) => {
            if (!wrapper.contains(e.target)) {
                dropdown.classList.add('hidden');
            }
        });
    }

    function setupMobileFavoritesToggle() {
        const toggleBtn = document.getElementById('mobile-favorites-toggle');
        const listContainer = document.getElementById('favorites-list-mobile');
        const chevron = document.getElementById('mobile-favorites-chevron');

        if (!toggleBtn || !listContainer) return;

        toggleBtn.addEventListener('click', () => {
            const isHidden = listContainer.classList.contains('hidden');

            if (isHidden) {
                listContainer.classList.remove('hidden');
                if (chevron) chevron.classList.add('rotate-180');
            } else {
                listContainer.classList.add('hidden');
                if (chevron) chevron.classList.remove('rotate-180');
            }
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        const subscriptionForm = document.getElementById("subscriptionForm");
        const submitButton = document.getElementById("submitFormSubscription");
        const responseMessage = document.getElementById("subscriptionResponse");

        subscriptionForm.addEventListener("submit", function (event) {
            event.preventDefault();

            const formData = {
                website: document.getElementById("website").value.trim(),
                websiteUrl: document.getElementById("websiteUrl").value.trim(),
                contactName: document.getElementById("contactName").value.trim(),
                email: document.getElementById("email").value.trim(),
                message: document.getElementById("message").value.trim(),
            };

            if (!formData.website || !formData.websiteUrl || !formData.contactName || !formData.email) {
                showMessage("Please fill in all required fields.", "text-red-500");
                return;
            }

            submitButton.disabled = true;
            submitButton.innerText = "Submitting...";

            fetch("/send-subscription", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        showMessage("Your subscription has been received. Thank you!", "text-green-500");
                        subscriptionForm.reset();
                    } else {
                        showMessage("Error: " + (data.error || "Failed to submit subscription."), "text-red-500");
                    }
                })
                .catch(error => {
                    showMessage("An unexpected error occurred. Please try again later.", "text-red-500");
                    console.error("Error submitting subscription:", error);
                })
                .finally(() => {
                    submitButton.disabled = false;
                    submitButton.innerText = "Subscribe";
                });
        });

        function showMessage(message, className) {
            responseMessage.innerText = message;
            responseMessage.className = "mt-4 text-center " + className;
            responseMessage.classList.remove("hidden");
        }
        bindFavoriteButtons();
        updateFavoriteIcons();
        renderFavoriteList();
        setupFavoritesDropdownToggle();
        setupMobileFavoritesToggle();
    });

}());
